export const PROD_DOMAIN = "https://tune.kr/";
export const PREVIEW_DOMAIN = "https://d3izttcuyjut7x.cloudfront.net/";
export const ARCHIVE_SALE_DOMAIN_LIST = ["https://archive-sale.tune.kr/", "https://d1hikmnu6twm78.cloudfront.net/"];

export const URLS = {
  HOME: "/",
  LOGIN: "/login",
  BRANDS: "/brands",
  SEARCH: "/search",
  WISHLIST: "/wishlist",
  MEMBERSHIP_PROGRAM: "/membership-program",

  // Checkout
  CHECKOUT: "/checkout",
  CHECKOUT_V2: "/checkout-v2",
  ORDER_COMPLETED: "/order-completed/:orderId",
  CHECKOUT_PAYMENT: "/checkout/payment/:handle",

  // Products
  PRODUCTS: "/products",
  PRODUCTS_DETAIL: "/products/:handle",
  PRODUCT_TEST: "/products/test-attack-qs-sp-nk231xsesn60",

  // Collections
  COLLECTIONS: "/collections",
  COLLECTIONS_DETAIL: "/collections/:handle",
  COLLECTIONS_ALL: "/collections/all",
  COLLECTIONS_ALL_ARCHIVE_SALE: "/collections/all-archive-sale",
  COLLECTIONS_NEW: "/collections/new-arrivals",

  // Draw
  DRAW: "/launches",
  DRAW_DETAIL: "/launches/:handle",
  DRAW_ENTRY: "/draw-entry",
  DRAW_ENTRY_DETAIL: "/draw-entry/:variantId",
  DRAW_ENTERED: "/draw-entered",
  DRAW_ENTERED_DETAIL: "/draw-entered/:orderId",

  // Community Program
  COMMUNITY_PROGRAM: "/program",
  COMMUNITY_PROGRAM_DETAIL: "/program/:handle",
  COMMUNITY_PROGRAM_COMPLETED: "/program/apply-completed",
  COMMUNITY_PROGRAM_COMPLETED_DETAIL: "/program/apply-completed/:handle",

  // Checkin
  CHECKIN: "/check-in",
  CHECKIN_DETAIL: "/check-in/:handle",

  // Features
  FEATURES: "/features",
  FEATURES_DETAIL: "/features/:handle",
  FEATURES_TEST: "/features/test-091231",

  // Account
  ACCOUNT: "/account",
  ACCOUNT_ORDER: "/account/order",
  ACCOUNT_ORDER_DETAIL: "/account/order/:orderId",
  ACCOUNT_ORDER_HISTORY: "/account/order-history",
  ACCOUNT_DRAW: "/account/draw",
  ACCOUNT_DRAW_DETAIL: "/account/draw/:orderId",
  ACCOUNT_DRAW_HISTORY: "/account/draw-history",
  ACCOUNT_EVENT_HISTORY: "/account/event-history",
  ACCOUNT_MEMBERSHIP_PROGRAM: "/account/membership-program",
  ACCOUNT_PERSONAL_INFORMATION: "/account/personal-information",
  ACCOUNT_SHIPPING_ADDRESS: "/account/shipping-address",
  ACCOUNT_RETURN_REQUEST: "/account/return-request/:orderId",
  ACCOUNT_RETURN_REQUEST_DETAIL: "/account/return-request",
  ACCOUNT_RETURN_REQUESTED: "/account/return-requested/:orderId",
  ACCOUNT_RETURN_REQUESTED_DETAIL: "/account/return-requested",

  //Sub Pages
  PAGES: "/pages",
  PAGES_CS: "/pages/customer-service",
  PAGES_SHIPPING_INFORMATION: "/pages/shipping-information",
  PAGES_MEMBERSHIP_PROGRAM: "/pages/membership-program",
  PAGES_RETURN_AND_EXCHANGE: "/pages/return-and-exchange",
  PAGES_OFFLINE_STORES: "/pages/stores",
  PAGES_PRIVACY_POLICY: "/pages/privacy-policy",
  PAGES_TERMS_AND_CONDITIONS: "/pages/terms-and-conditions",

  // Season Off Sale
  SALE: "/sale",

  //Out Link
  INSTAGRAM: "https://instagram.com/tune.kr",
  APPLE_MUSIC: "https://music.apple.com/us/curator/tune/1723813282",
  SPOTIFY: "https://open.spotify.com/user/31thg2sewospcbzh3wogsw6x3fgq?si=71f6d30c9e0a43cf",
  KAKAO_PLUS: "https://pf.kakao.com/_TxdCmxj",

  NOT_FOUND: "/404",
  KAKAO_OAUTH: "/kakao/oauth",

  REFRESH: "/refresh",

  // Event Page
  TEKKEN: "/tekken8",
  TEKKEN_NIKE: "/tekken8-nike",
  ON_SEOUL_POPUP: "/on-seoul-popup",
};
